/**
 * Whether a session's lifecycle status means "no longer a customer".
 *
 * Mirrors `isSuppressedStatus` in the api (`@/schemas/customer-lifecycle`) and is
 * fail-closed for the same reason: any non-empty value other than the literal
 * `"active"` counts as offboarded, including one this build does not recognise.
 * If a later deploy introduces another status, an older frontend must not keep
 * showing a former customer their dashboard.
 *
 * Absent/null means active — the field only exists on customers who have been
 * offboarded at least once.
 */
export function isOffboarded(status: unknown): boolean {
  return typeof status === "string" && status.trim() !== "" && status.trim() !== "active";
}
